import React from 'react';
import { MapPin, Clock, Home, Bath } from 'lucide-react';
interface Property {
  id: number;
  address: string;
  mq: number;
  rooms: number;
  bathrooms: number;
  timeWindow: string;
  tags: string[];
  lat: number;
  lng: number;
}
interface PropertyHoverTooltipProps {
  property: Property;
  index: number;
  position: {
    x: number;
    y: number;
  };
  visible: boolean;
}
export function PropertyHoverTooltip({
  property,
  index,
  position,
  visible
}: PropertyHoverTooltipProps) {
  if (!visible) return null;
  return <div className="absolute z-[1000] pointer-events-none transition-opacity duration-150" style={{
    left: position.x,
    top: position.y - 12,
    transform: 'translate(-50%, -100%)',
    opacity: visible ? 1 : 0
  }} data-id="element-1587">
      <div className="bg-white rounded-lg shadow-xl border border-gray-200 p-3 w-[220px] relative" data-id="element-1588">
        {/* Arrow pointing down */}
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-3 h-3 bg-white border-r border-b border-gray-200 transform rotate-45" data-id="element-1589" />

        <div className="relative z-10" data-id="element-1590">
          {/* Address */}
          <div className="flex items-start gap-2 mb-2" data-id="element-1591">
            <div className="w-5 h-5 rounded-full bg-teal-deep text-white flex items-center justify-center flex-shrink-0 text-[10px] font-bold" data-id="element-1592">
              {index}
            </div>
            <p className="text-xs font-semibold text-navy leading-tight" data-id="element-1593">
              {property.address}
            </p>
          </div>

          {/* Quick stats */}
          <div className="flex items-center gap-2.5 text-[11px] text-gray-500 mb-2" data-id="element-1594">
            <span className="font-medium" data-id="element-1595">{property.mq} mq</span>
            <span className="w-0.5 h-0.5 bg-gray-300 rounded-full" data-id="element-1596" />
            <div className="flex items-center gap-1" data-id="element-1597">
              <Home size={10} className="text-gray-400" data-id="element-1598" />
              <span data-id="element-1599">{property.rooms}</span>
            </div>
            <span className="w-0.5 h-0.5 bg-gray-300 rounded-full" data-id="element-1600" />
            <div className="flex items-center gap-1" data-id="element-1601">
              <Bath size={10} className="text-gray-400" data-id="element-1602" />
              <span data-id="element-1603">{property.bathrooms}</span>
            </div>
          </div>

          {/* Time window */}
          <div className="flex items-center gap-1.5 text-[11px] text-gray-600 bg-gray-50 rounded-md px-2 py-1 mb-2 border border-gray-100" data-id="element-1604">
            <Clock size={10} className="text-gray-400" data-id="element-1605" />
            <span data-id="element-1606">{property.timeWindow}</span>
          </div>

          {/* Tags */}
          {property.tags.length > 0 && <div className="flex flex-wrap gap-1" data-id="element-1607">
              {property.tags.map(tag => <span key={tag} className="px-1.5 py-0.5 bg-gray-50 text-gray-600 rounded text-[10px] font-medium border border-gray-100" data-id="element-1608">
                  {tag}
                </span>)}
            </div>}
        </div>
      </div>
    </div>;
}